import { useState } from "react";
import { Button } from "./button";

interface VideoReconnectOverlayProps {
  onReconnect: () => Promise<any>;
}

export function VideoReconnectOverlay({
  onReconnect,
}: VideoReconnectOverlayProps) {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <div className="absolute bg-black flex z-[100] items-center justify-center aspect-video w-[350px]">
      <div className="text-center">
        <p className="text-white mb-4">
          Try to refresh for reconnecting to video stream
        </p>
        <Button
          onClick={() => {
            setIsLoading(true);
            onReconnect().finally(() => {
              setIsLoading(false);
            });
          }}
          isLoading={isLoading}
          className="no-draggable font-semibold mx-auto bg-white hover:bg-gray-100 disabled:bg-white px-5"
        >
          Reconnect
        </Button>
      </div>
    </div>
  );
}
